import { AbstractControl, ValidationErrors } from "@angular/forms";
import { differenceInYears, format, parse } from "date-fns";
import * as hijriMoment from 'moment-hijri';
export class JariValidators {
   static validStringRegex = /^[^*|\":<>[\]{}`\\()';@&$]+$/;
   static emailPattern:string = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
   static saudiNationalIdPattern =  /^(1|2)[0-9]{9}$/;
   static validPhoneNumberRegex =  /^5[0-9]{8}$/;
   static validPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,16}$/;
   static englishArabicNoNumbersPattern = /^[\p{L}A-Za-z\s]+$/u;
   static validStringForEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   static isValidPhoto(file: File): boolean {
      const allowedExtensions = ['image/png', 'image/jpg', 'image/jpeg'];
      return allowedExtensions.includes(file.type);
   }
   static saPattern = /^SA[A-Z0-9]{22}$/;

   
}
export function dateNotInFutureValidator(dateType: 'gregorian' | 'hijri') {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    let selectedDate: Date;

    if (dateType === 'gregorian') {
      selectedDate = new Date(control.value);
    } else {
      const parts = control.value.split('/');
      if (parts.length !== 3) return null;
      const [year, month, day] = parts.map(Number);
      selectedDate = hijriMoment(`${year}/${month}/${day}`, 'iYYYY/iM/iD').toDate();
    }

    const today = new Date();
    today.setHours(0,0,0,0);

  return selectedDate >= today ? { futureDate: true } : null;
  };
}
export function ageValidator(minAge: number) {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value) return null;

    const dateValue = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dateValue > today) return null;

    const age = differenceInYears(today, dateValue);
    if (age < minAge) {
      return { ageInvalid: true };
    }
    return null;
  };
}
